import { Box, Chip, Typography } from "@mui/material";
import { useAppTheme } from "@/hooks/useAppTheme";
import type { TaskTemplate } from "@/types";

interface BusinessLogicSectionProps {
  template: TaskTemplate;
}

export const BusinessLogicSection = ({ template }: BusinessLogicSectionProps) => {
  const { isDarkMode } = useAppTheme();
  const businessLogic = template.business_logic;

  if (!businessLogic) {
    return (
      <Typography variant="body2" color="text.secondary">
        No automation rule configured.
      </Typography>
    );
  }

  return (
    <Box>
      {/* Description */}
      {businessLogic.description && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          {businessLogic.description}
        </Typography>
      )}

      {/* Rule Text */}
      <Box
        sx={{
          p: 2,
          borderRadius: 1,
          bgcolor: isDarkMode ? "grey.900" : "grey.100",
          border: 1,
          borderColor: "divider",
          fontFamily: "monospace",
          fontSize: "0.85rem",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          overflow: "auto",
          maxHeight: 300,
        }}
      >
        {businessLogic.rule_text}
      </Box>

      {/* Required Facts */}
      {businessLogic.required_facts && businessLogic.required_facts.length > 0 && (
        <Box mt={1.5}>
          <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: "block" }}>
            Required Facts
          </Typography>
          <Box display="flex" gap={0.5} flexWrap="wrap">
            {businessLogic.required_facts.map((fact) => (
              <Chip key={fact} label={fact} size="small" variant="outlined" />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};
